<template>
    <div>
      <div class="text" ref="box" style="height:100px;width:100px;overflow-y:scroll;border:solid red 1px;margin-left:200px;">
          <div style="height:1000px;">
              发生的发生的发生的发的所发生的反倒是发生的发送到发多少放到沙发斯蒂芬发送到发送到放到沙发上
          </div>
      </div>
    </div>
</template>
<script>
export default {
    data(){
      return {}
    },
    mounted(){
      let box = this.$refs.box.scrollTop = 1000
    }

}
</script>